import { createApiHook } from './utils/createApiHook';
import { AchRepository, AchTransfer, BookRepository, BookTransfer, WireRepository, WireTransfer } from '~/repositories';
import { CheckRepository, CheckTransfer, GetCheckTransferRequest } from '~/repositories/Transfer/CheckRepository';
import { InternationalWireTransfer } from '~/typings/API';

export type TransferID = 'ach' | 'wire' | 'book' | 'intl-wire';
export type TransferType = AchTransfer | WireTransfer | BookTransfer | InternationalWireTransfer;
type TransferResponse = (params: string) => Promise<TransferType>;

const TransferMethods = new Map<TransferID, TransferResponse>([
  ['ach', AchRepository.get],
  ['wire', WireRepository.get],
  ['book', BookRepository.get],
  ['intl-wire', WireRepository.getSwift],
]);

export const useTransfer = (type: TransferID) =>
  createApiHook<TransferType, string>(TransferMethods.get(type) as TransferResponse);

export const useCheckTransfer = createApiHook<CheckTransfer, GetCheckTransferRequest>(CheckRepository.get, {
  triggerAutomatically: true,
  triggerOnSessionStoreSubscribe: true,
});
